var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 15.625C13.3995 15.625 15.75 13.2745 15.75 10.375C15.75 7.4755 13.3995 5.125 10.5 5.125C7.6005 5.125 5.25 7.4755 5.25 10.375C5.25 11.3166 5.49787 12.2003 5.93193 12.9644L5.25 15.625L7.99307 14.9889C8.73802 15.3945 9.59209 15.625 10.5 15.625ZM10.5 14.8173C12.9534 14.8173 14.9423 12.8284 14.9423 10.375C14.9423 7.92158 12.9534 5.93269 10.5 5.93269C8.04658 5.93269 6.05769 7.92158 6.05769 10.375C6.05769 11.3223 6.35419 12.2003 6.85944 12.9213L6.46154 14.4135L7.97997 14.0339C8.69601 14.528 9.56422 14.8173 10.5 14.8173Z",
    fill: "#BFC8D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C15 12.4853 12.9853 14.5 10.5 14.5C9.55206 14.5 8.67258 14.2069 7.94725 13.7064L6.40909 14.0909L6.81216 12.5794C6.30035 11.849 6 10.9596 6 10C6 7.51472 8.01472 5.5 10.5 5.5C12.9853 5.5 15 7.51472 15 10Z",
    fill: "url(#paint0_linear_2454_162890)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 15.25C13.3995 15.25 15.75 12.8995 15.75 10C15.75 7.1005 13.3995 4.75 10.5 4.75C7.6005 4.75 5.25 7.1005 5.25 10C5.25 10.9416 5.49787 11.8253 5.93193 12.5894L5.25 15.25L7.99307 14.6139C8.73802 15.0195 9.59209 15.25 10.5 15.25ZM10.5 14.4423C12.9534 14.4423 14.9423 12.4534 14.9423 10C14.9423 7.54658 12.9534 5.55769 10.5 5.55769C8.04658 5.55769 6.05769 7.54658 6.05769 10C6.05769 10.9473 6.35419 11.8253 6.85944 12.5463L6.46154 14.0385L7.97997 13.6589C8.69601 14.153 9.56422 14.4423 10.5 14.4423Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18751 7.56252C9.06268 7.3118 8.8712 7.334 8.67775 7.334C8.33204 7.334 7.79297 7.7481 7.79297 8.51879C7.79297 9.15042 8.07129 9.84182 9.00916 10.8761C9.91427 11.8743 11.1035 12.3906 12.0908 12.373C13.0781 12.3555 13.2813 11.5059 13.2813 11.2189C13.2813 11.0918 13.2023 11.0283 13.148 11.0111C12.8115 10.8496 12.191 10.5487 12.0498 10.4922C11.9086 10.4357 11.8349 10.5121 11.7891 10.5537C11.661 10.6758 11.4072 11.0354 11.3203 11.1162C11.2334 11.1971 11.1039 11.1562 11.0499 11.1256C10.8515 11.046 10.3136 10.8067 9.8848 10.391C9.3545 9.87698 9.32337 9.70011 9.22346 9.54268C9.14353 9.41673 9.20219 9.33945 9.23145 9.30568C9.34571 9.17385 9.50348 8.97031 9.57423 8.86916C9.64498 8.76801 9.58881 8.61444 9.55511 8.5188C9.41016 8.10744 9.28737 7.76309 9.18751 7.56252Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2454_162890",
    x1: 14.4375,
    y1: 6.625,
    x2: 6,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B43E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon.d91902c03acf5fd42f126cd495f09822.svg";
export { ForwardRef as ReactComponent };